<template>
  <div
    class="ax-step-box"
    v-if="data.checkStatusText || data.jumpType == 'UNHANDLE'"
  >
    <div
      class="step-box"
      v-if="
        data.checkStatusText &&
        data.checkStatus !== 'UNHANDLE' &&
        data.checkStatus != 'NULLUSERSKIP'
      "
    >
      <div class="step-top" :class="statusTemp[data.checkStatus]">
        <div class="status"></div>
        <!-- 沟通任务-->
        <div class="status-text" v-if="data.jumpType == 'COMMUNICATE'">
          【{{ data.handler }} 与 {{ data.checkStatusText }} 沟通历史记录】
        </div>
        <div class="status-text" v-else>
          【{{ data.checkStatusText }}】
          <span
            v-if=" data.labelColor && data.labelName "
            class="risk"
            :style="{ color: data.labelColor }"
            >{{ data.labelName }}</span
          >
        </div>
      </div>
      <!-- 沟通任务-->
      <template v-if="data.jumpType == 'COMMUNICATE'">
        <div class="status"></div>
        <ax-communication-step
          from="record"
          :stepData="data"
        ></ax-communication-step>
      </template>
      <div v-else class="step-content">
        <div class="details">
          <div class="details-l">
            <h6 v-if="data.handler">
              {{ data.handler }}
              <span>{{ data.nodeName || "审批人" }}</span>
            </h6>
            <div class="dept" v-if="data.handlerInfo">
              {{ data.handlerInfo.deptName }}
            </div>
            <p>{{ data.updateTime }}</p>
          </div>
          <div
            class="details-r"
            @click="collapse"
            v-if="
              (data.remark !== null && data.remark !== '') ||
              data.attachments.length ||
              comment.length
            "
          >
            审批意见
            <van-icon :class="active ? 'icon_active' : ''" name="arrow" />
          </div>
        </div>
        <div class="contents" ref="content" style="height: 0">
          <p v-if="data.remark && data.remark !== '' && data.remark !== '无'" 
          :style="{padding: '5px', backgroundColor: hexToRgba( data.labelColor, 0.1)}">
            <template v-if="data.labelName">
              <span class="risk-name" :style="{ color: data.labelColor }"
                >{{ data.labelName }}附言：</span
              >
              <br />
            </template>
            {{ data.remark }}
          </p>
          <template v-if="data.attachments.length !== 0">
            <ax-down
              v-for="(fileItem, index) in data.attachments"
              type="ssc"
              :data="fileItem"
              :key="index"
            ></ax-down>
          </template>
          <template v-if="comment">
            <div
              v-for="(itemComments, indexComments) in comment"
              :key="indexComments"
            >
              <template v-if="data.labelName">
                <p :style="{padding: '5px', backgroundColor: hexToRgba( data.labelColor, 0.1)}">
                  <span class="risk-name" :style="{ color: data.labelColor }"
                    >{{ data.labelName }}附言：</span
                  >
                  <br />
                  {{ itemComments.comments }}
                </p>
              </template>
              <p v-else>附言: {{ itemComments.comments }}</p>
              <template v-if="itemComments.sysFileList.length !== 0">
                <ax-down
                  v-for="(itemFile, indexFile) in itemComments.sysFileList"
                  type="ssc"
                  :data="itemFile"
                  :key="indexFile"
                ></ax-down>
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- 当前审批人 -->
    <div
      class="step-box"
      v-if="
        data.jumpType == 'UNHANDLE' &&
        data.currApproveUserList &&
        data.currApproveUserList[0]
      "
    >
      <div class="step-top" :class="statusTemp[data.jumpType]">
        <div class="status"></div>
        <div class="status-text">【审批中】</div>
      </div>
      <div class="step-content">
        <div class="details">
          <div class="details-l">
            <h6 v-if="data.currApproveUserList && data.currApproveUserList[0]">
              {{ data.currApproveUserList[0].currApproveUserName }}
              <span>{{ data.nodeName || "审批人" }}</span>
            </h6>
            <p>
              <a
                :href="
                  'tel:' + data.currApproveUserList[0].currApproveUserPhone
                "
                >{{ data.currApproveUserList[0].currApproveUserPhone }}</a
              >
            </p>
          </div>
          <div
            class="details-r"
            v-if="data.currApproveUserList.length > 1"
            @click="showCurrentMoreFlag = !showCurrentMoreFlag"
          >
            <van-icon
              :class="showCurrentMoreFlag ? 'icon_active' : ''"
              name="arrow"
            />
          </div>
        </div>
        <template
          v-if="data.currApproveUserList.length > 1 && showCurrentMoreFlag"
        >
          <div
            class="details"
            v-for="(item, ii) in data.currApproveUserList"
            :key="ii"
          >
            <div class="details-l" v-if="ii">
              <h6 v-if="item.currApproveUserName">
                {{ item.currApproveUserName }}
                <span>{{ data.nodeName || "审批人" }}</span>
              </h6>
              <p>
                <a :href="'tel:' + item.currApproveUserPhone">{{
                  item.currApproveUserPhone
                }}</a>
              </p>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import AxCommunicationStep from "./AxCommunicationStep.vue";

export default {
  name: "ax-step",
  components: { AxCommunicationStep },
  props: {
    data: [Object],
    comment: [Array],
  },
  data() {
    return {
      showCurrentMoreFlag: true,
      timer: null,
      active: false,
      statusTemp: {
        AGREE: "block_agree",
        RECOVER: "block_reject",
        BACK_TO_END: "block_refuse",
        BACK_TO_STARTOR: "block_refuse",
        BACK: "block_reject",
        UNHANDLE: "block_ing",
      },
    };
  },
  methods: {
    collapse() {
      this.active = !this.active;
      let height = this.$refs.content.getBoundingClientRect().height;
      if (!!height) {
        this.$refs.content.style.height = height + "px";
        var f = document.body.offsetHeight;
        this.$refs.content.style.height = "0px";
      } else {
        this.$refs.content.style.height = "auto";
        height = this.$refs.content.getBoundingClientRect().height;
        this.$refs.content.style.height = "0";
        var f = document.body.offsetHeight;
        this.$refs.content.style.height = height + "px";
        var _this = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          _this.$refs.content.style = null;
        }, 300);
      }
    },
    //hex -> rgba
    hexToRgba(hex, opacity) {
      // hex = '#bfbbb4'
      if(!hex || typeof hex != 'string') return '';
      return (
        "rgba(" +
        parseInt("0x" + hex.slice(1, 3)) +
        "," +
        parseInt("0x" + hex.slice(3, 5)) +
        "," +
        parseInt("0x" + hex.slice(5, 7)) +
        "," +
        opacity +
        ")"
      );
    },
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.ax-step-box {
  width: 100%;

  &:last-child {
    .step-box {
      border-color: transparent;
    }
  }

  .risk {
    font-size: 14px;
  }
  .risk-name {
    font-size: 12px;
    margin-bottom: 5px;
  }
  .step-box {
    border-color: transparent;

    .step-top {
      &.block_agree {
        .status {
          background-color: $link-a;
        }

        .status-text {
          color: $link-a;
        }
      }

      &.block_reject {
        .status {
          background-color: $reject-color;
        }

        .status-text {
          color: $reject-color;
        }
      }

      &.block_refuse {
        .status {
          background-color: $refuse-color;
        }

        .status-text {
          color: $refuse-color;
        }
      }

      &.block_ing {
        .status {
          background-color: #07c160;
        }

        .status-text {
          color: #07c160;
        }
      }
    }
  }

  .step-box {
    margin-left: 22px;
    padding-bottom: 11px;
    padding: 0 12px 12px 15px;
    border-left: 0.053333333rem solid $border-color;
    position: relative;
    border-top: 1px solid #fff;

    .step-top {
      height: 24px;

      .status {
        width: 12px;
        height: 12px;
        background-color: $border-color;
        border-radius: 50%;
        position: absolute;
        left: -7px;
        top: 0;
      }

      .status-text {
        margin-top: -6px;
        font-size: 17px;
        color: $value-color;
        line-height: 24px;
        text-indent: -0.5em;
      }
    }

    .step-content {
      .details {
        display: flex;
        align-items: center;
        padding-top: 8px;

        .details-l {
          flex: 1;

          h6 {
            font-size: 16px;
            color: #333;
            font-weight: inherit;
            line-height: 22px;

            span {
              background: rgba(0, 0, 0, 0.04);
              border-radius: 4px;
              font-size: 14px;
              color: $title-color;
              padding: 1px 5px;
            }

            em {
              font-style: normal;
              font-size: 12px;
            }
          }

          p {
            font-size: 14px;
            color: $title-color;
            line-height: 20px;
          }
        }

        .details-r {
          display: flex;
          align-items: center;
          font-size: 17px;
          color: #576b95;

          .van-icon {
            color: $value-color;
            margin-left: 8px;
            font-size: 16px;
            -webkit-transition: -webkit-transform 0.3s
              cubic-bezier(0.86, 0, 0.07, 1);
            transition: -webkit-transform 0.3s cubic-bezier(0.86, 0, 0.07, 1);
            transition: transform 0.3s cubic-bezier(0.86, 0, 0.07, 1);
            transition: transform 0.3s cubic-bezier(0.86, 0, 0.07, 1),
              -webkit-transform 0.3s cubic-bezier(0.86, 0, 0.07, 1);

            &.icon_active {
              transform: rotate(90deg);
            }
          }
        }
      }

      .contents {
        display: block;
        transition: height 0.3s;
        -webkit-transition: height 0.3s;
        margin-top: 17px;
        overflow: hidden;

        p {
          font-size: 15px;
          color: $des-color;
          line-height: 21px;
        }
      }
    }
  }
}
</style>
